export default __webpack_public_path__ + "static/media/ShareTablet.b131c715.png";